// [MCV-1894] 409/400 bodies from the managed-vault endpoints:
//   { detail, extra: { code, existingProviderId?, existingId? } }
export type ManagedErrorCode =
  | 'NPI_IN_USE'
  | 'EMAIL_IN_USE'
  | 'PENDING_REQUEST_EXISTS'
  | 'PROVIDER_HAS_ACCOUNT'
  | 'INVALID_NPI';

export type ManagedError = {
  code: ManagedErrorCode;
  existingProviderId: number | null;
  existingId: number | null;
};

const CODES: readonly string[] = [
  'NPI_IN_USE',
  'EMAIL_IN_USE',
  'PENDING_REQUEST_EXISTS',
  'PROVIDER_HAS_ACCOUNT',
  'INVALID_NPI',
];

type ShapedError = {
  response?: { data?: { extra?: Record<string, unknown> } };
};

const asId = (value: unknown): number | null =>
  typeof value === 'number' && Number.isInteger(value) ? value : null;

/** The managed-vault error code an API failure carries, or null for anything else. */
export function getManagedError(error: unknown): ManagedError | null {
  if (error == null || typeof error !== 'object' || !('response' in error)) return null;
  const extra = (error as ShapedError).response?.data?.extra;
  const code = extra?.code;
  if (typeof code !== 'string' || !CODES.includes(code)) return null;
  return {
    code: code as ManagedErrorCode,
    existingProviderId: asId(extra?.existingProviderId),
    existingId: asId(extra?.existingId),
  };
}
